const nextArrow = `<svg class="next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>`;
const prevArrow = `<svg class="prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg>`;

$(document).ready(function () {
  $(".video-slick-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px"
        },
      },
    ],
  });
});

const videos_container = document.querySelectorAll(
  ".video-carousel .video-card"
);
videos_container.forEach((item) => {
  item.addEventListener("click", () => {
    const video = item.querySelector("video");
    video &&
      (video.paused
        ? (video.classList.add("active_video_play"), video.play())
        : (video.pause(), video.classList.remove("active_video_play")));
  });
});
